const lstTypeDocument = [
    { value: '1', text: 'Cédula' },
    { value: '2', text: 'Pasaporte' },
    { value: '3', text: 'Residencia' },
]

const lstSearchFilter = [
    { value: '1', text: 'Identificación del asegurado' },
    { value: '2', text: 'Nombre del asegurado' },
    { value: '3', text: 'No. de oferta' },
]

const siteTitleMain: Array<string> = [
    'Compre su Seguro de Vida en línea aquí',
    'Compre su Seguro de Vida en línea aquí',
    'Compre su Seguro de Vida en línea aquí',
    'Compre su Seguro de Vida en línea aquí',
    'Compre su Seguro de Vida en línea aquí',
    'Compre su Seguro de Vida en línea aquí',
    'Compre su Seguro de Vida en línea aquí',
]

const txtBack = 'Atrás';
const txtNext = 'Siguiente';
const txtSave = 'Generar Oferta';

const GetLstPageTitle = () => {
    let lstPageTitle: Array<IPageInfo> = []
    const txtHead1 = "Compre su Seguro de Vida en línea aquí";
    const txtHead2 = "Registrado ante la SUGESE bajo el nombre de SEGURO AUTOEXPEDIBLE DE VIDA Y GASTOS FUNERARIOS y número de Registro P14-26-A14-1049 de Seguros";

    lstPageTitle.push({
        indexBar: 1,
        title1: 'Datos personales',
        title2: '(*) Espacios requeridos',
        title3: '¡Queremos conocerte! Ingresá los siguientes datos, según tu documento de identidad',
        txtBtnNext: txtNext,
        txtHead1: txtHead1,
        txtHead2: txtHead2
    } as IPageInfo)

    lstPageTitle.push({
        indexBar: 2,
        title1: 'Planes, coberturas y suma asegurada',
        title2: '(*) Espacios requeridos',
        title3: 'Puede seleccionar la moneda de su seguro y conocer las sumas aseguradas y coberturas por plan ',
        txtBtnBack: txtBack,
        txtBtnNext: txtNext,
        txtHead1: txtHead1,
        txtHead2: txtHead2
    } as IPageInfo)

    lstPageTitle.push({
        indexBar: 3,
        title1: 'Continuación de datos personales',
        title2: '(*) Espacios requeridos',
        title3: '',
        txtBtnBack: txtBack,
        txtBtnNext: txtNext,
        txtHead1: txtHead1,
        txtHead2: txtHead2
    } as IPageInfo)

    lstPageTitle.push({
        indexBar: 4,
        title1: 'Declaración de Beneficiarios',
        title2: '(*) Espacios requeridos',
        title3: 'Podes declarar a tus beneficiarios. Puede ser tu pareja, tus hijos, tus papás, ¡vos decidís!',
        txtBtnBack: txtBack,
        txtBtnNext: txtNext,
        txtHead1: txtHead1,
        txtHead2: txtHead2
    } as IPageInfo)

    lstPageTitle.push({
        indexBar: 5,
        title1: 'Resumen de compra',
        title2: '',
        title3: 'A continuación le presentamos un resumen de la compra de su póliza de Vida y Gatos Funerarios Autoexpedible',
        txtBtnBack: txtBack,
        txtHead1: txtHead1,
        txtHead2: txtHead2
    } as IPageInfo)
    lstPageTitle.push({
        indexBar: 5,
        title1: 'Resumen de compra',
        title2: '',
        title3: 'A continuación le presentamos un resumen de la compra de su póliza de Vida y Gatos Funerarios Autoexpedible',
        txtBtnNext: txtNext,
        txtHead1: txtHead1,
        txtHead2: txtHead2
    } as IPageInfo)

    lstPageTitle.push({
        indexBar: -1,
        title1: '',
        title2: '',
        title3: '',     
       
    } as IPageInfo)

    lstPageTitle.push({
        indexBar: -1,
        title1: '',
        title2: '',
        title3: '',
        txtHead1: '',
        txtHead2: ''
    } as IPageInfo)

    
    lstPageTitle.push({
        indexBar: -1,
        title1: '',
        title2: '',
        title3: '',
        txtHead1: '',
        txtHead2: ''
    } as IPageInfo)



    return lstPageTitle;
}

const lstPageTitle: Array<IPageInfo> = [

]

const customStyles: any = {
    option: (provided: any, state: any) => {
        return {
            ...provided,
            fontSize: '15px',
            padding: '4px 12px',
            backgroundColor: state.isSelected ? "#008964" : "white",
            color: state.isSelected ? "white" : "#4D4D4D",

        }
    },
    indicatorSeparator: (provided: any, state: any) => { },
    indicatorsContainer: (provided: any, state: any) => {
        return {
            ...provided,
            height: 27,
            padding: 0,

        }
    },
    control: (provided: any, state: any) => {
        return {
            ...provided,
            minHeight: 35,
            border: "1px solid #e4e4e4",
            height: 30,
            width: "100%",
            fontSize: '15px',
            backgroundColor: '#f7f7f7',
            borderRadius: 0,
            borderColor: state.isFocused && "",
            // color:'#4D4D4D',
            boxShadow: 0,
            "text-align-last": "left",
            '&:hover': {
                border: '0 !important',
            },
            selectProps: {
                backgroundColor: "#008964",
                color: '#ffffff'
            }
        }
    },
    menu: (provided: any, state: any) => {
        return {
            ...provided,
            borderRadius: 0,
        }
    },
    placeholder: (provided: any, state: any) => {
        return {
            ...provided,
            "text-align": "center",
        }
    },
    singleValue: (provided: any, state: any) => {
        return {
            ...provided,
            opacity: state.isDisabled ? 0.5 : 1,
            transition: 'opacity 300ms',
        }
    },
}

const catPlan = [
    { value: '610', text: 'Dólares' },
    { value: '611', text: 'Colones' },
]

const catSumInsuredColones = [
    { value: '3000000', text: '₡ 3,000,000' },
    { value: '6000000', text: '₡ 6,000,000' },
    { value: '9000000', text: '₡ 9,000,000' },
    { value: '12000000', text: '₡ 12,000,000' },
    { value: '20000000', text: '₡ 20,000,000' },
]

const catSumInsuredDolar = [
    { value: '5000', text: 'U$ 5,000' },
    { value: '10000', text: 'U$ 10,000' },
    { value: '15000', text: 'U$ 15,000' },
    { value: '20000', text: 'U$ 20,000' },
    { value: '40000', text: 'U$ 40,000' },
]

const catCoveragesName = [
    { value: '517', text: 'Cobertura Básica' },
    { value: '518', text: 'Gastos Funerarios' },
    { value: '538', text: 'Asistencia Salud' },
]

const catSexo = [
    { value: '1', text: 'Femenino', text2: 'F' },
    { value: '2', text: 'Masculino', text2: 'M' },
];


const enum stepEnum {
    StepPersonalData,
    StepPlansCoverage,
    StepPersonalData2,
    StepBeneficiaries,
    StepPurcharseSummary,
    StepAutomaticPayment,
    StepPaymentCompleted,
    StepFinish,
    StepFinishAge
}

const catRelationship = [
    { value: '10', text: 'Sobrino (a)' },
    { value: '13', text: 'Esposo' },
    { value: '14', text: 'Esposa' },
    { value: '16', text: 'Albacea' },
    { value: '19', text: 'Nieto (a)' },
    { value: '20', text: 'Novio (a)' },
    { value: '21', text: 'Hijastra' },
    { value: '24', text: 'Pareja' },
    { value: '25', text: 'Ex-Esposa' },
    { value: '27', text: 'Prima (o)' },
    { value: '28', text: 'Mama De Crianza' },
    { value: '3', text: 'Padre' },
    { value: '30', text: 'Bisabuela' },
    { value: '31', text: 'Madrina' },
    { value: '35', text: 'Nuera' },
    { value: '37', text: 'Exconyuge' },
    { value: '39', text: 'Padrino' },
    { value: '4', text: 'Madre' },
    { value: '41', text: 'Madrasta' },
    { value: '42', text: 'Padrasto' },
    { value: '43', text: 'Hijastro' },
    { value: '5', text: 'Cuñado (a)' },
    { value: '6', text: 'Suegro (a)' },
    { value: '7', text: 'Tio (a)' },
    { value: '8', text: 'Abuelo (a)' },
    { value: '9', text: 'Hermano (a)' },
    { value: 'E', text: 'Conyuge' },
    { value: 'H', text: 'Hijo (a)' },
];


const catSiNo: Array<ICatalog> = [
    { value: 'S', text: 'Si' } as ICatalog,
    { value: 'N', text: 'No' } as ICatalog
]
const catCardType: Array<ICatalog> = [
    { value: 'TR', text: 'Débito' } as ICatalog,
    { value: 'TZ', text: 'Crédito' } as ICatalog
]


export {
    lstTypeDocument,
    lstSearchFilter,
    siteTitleMain,
    lstPageTitle,
    customStyles,
    GetLstPageTitle,
    catPlan,
    catSumInsuredDolar,
    catSumInsuredColones,
    catCoveragesName,
    stepEnum,
    catSexo,
    catRelationship,
    catSiNo,
    catCardType
}